import { jitsiLocalStorage } from '@jitsi/js-utils';
import React from 'react';

import { stateType } from '../../../app/stateTypes';
import { getConferenceName } from '../../../base/conference';
import { getToolbarButtons } from '../../../base/config';
import { getPictureInPictureModeConfig } from '../../../base/config/functions.any';
import { getWindowWidth } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions.js';
import {
    FixedIcon,
    FloatingIcon,
    Icon,
    IconDonorBoxSettings,
    IconExitDoor,
    IconExitFullScreen,
    IconEyeOff,
    IconFullScreen,
    IconParticipants,
    IconShareDesktop
} from '../../../base/icons';
import { MHRecordingConstants } from '../../../base/lib-meet-hour';
import {
    getParticipantCount
} from '../../../base/participants';
import Watermarks from '../../../base/react/components/web/Watermarks';
import { connect } from '../../../base/redux';
import { getBrandingColorPalette } from '../../../base/styles';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import ClickPledgeIndicator from '../../../clickandpledge-givent/components/web/ClickPledgeIndicator.js';
import { ColoredIcon } from '../../../participants-pane/components/styled';
import { startScreenShareFlow } from '../../../screen-share/actions.web';
import SettingsButton from '../../../settings/components/web/SettingsButton';
import { LAYOUTS } from '../../../video-layout';
import VisitorsCountLabel from '../../../visitors/components/web/VisitorsCountLabel';
import { iAmVisitor } from '../../../visitors/functions';
import VoiceCommandLabel from '../../../voice-command/components/web/VoiceCommandLabel';
import { goLive } from '../../../webinar/actions';
import { amIHeldBackstage, amIInBackstage } from '../../../webinar/functions';
import { conferenceViewHandler } from '../../actions.web';
import ConferenceTimer from '../ConferenceTimer';
import MeetingCountDown from '../MeetingCountDown.js';

import MenuSideBar from './MenuSideBar';

declare var interfaceConfig: Object;
declare var config: Object;

type Props = {

    // From Redux
    _iAmVisitor: boolean,
    _inBackstage: boolean,

    /**
     * Whether the local participant is held backstage by the server until a
     * moderator brings them live (no Go Live control for them).
     */
    _heldBackstage: boolean,
    _isLocalScreenSharing: boolean,
    _localParticipantName?: string,
    _remoteScreenshareParticipantNames?: string,
    _iAmRecorder: boolean,
    _subject: string,
    _conferenceSubject: string,
    _participantCount: number,
    _isShowingLabels: boolean,
    _geturl: string,
    clickAndPledgeUrl: string,
    _isPictureInPictureEnabled: boolean,
    _clickandpledgeform: ?string,
    _isClickandPledgeEnabled: boolean,
    _conferenceView: string,
    _fullScreen: boolean,
    filmStripView: string,
    hasMeetingEndTime: boolean,
    joinanytime: boolean,
    isDeskTop: boolean,
    SHOW_MEET_HOUR_WATERMARK: boolean,
    displayLogoInRecorder: boolean,
    lobbyEnabled: boolean,
    interfaceConfigToolbarButtons: Array<string>,
    dispatch: Function,
    t: Function,

    // From Conference parent (class instance methods / state)
    hasShownExpiringNotification: boolean,
    onExpiringNotificationShown: Function,
    onOpenDialog: Function,
    onToolbarToggleFullScreen: Function,
    renderE2EELabel: Function,
    renderInsecureRoomNameLabel: Function,
    renderLocalRecordingLabel: Function,
    renderRecordingLabel: Function,
    renderTranscribingLabel: Function,
    toggleParticipantsPane: Function
};

/**
 * The Conference Header component.
 * Reads most state from Redux, and only receives class-bound callbacks from parent.
 */
const HeaderConference = (props: Props) => {
    const {
        _iAmVisitor,
        _inBackstage,
        _heldBackstage,
        _isLocalScreenSharing,
        _remoteScreenshareParticipantNames,
        _iAmRecorder,
        _subject,
        _conferenceSubject,
        _participantCount,
        _isShowingLabels,
        _geturl,
        clickAndPledgeUrl,
        _isPictureInPictureEnabled,
        _clickandpledgeform,
        _isClickandPledgeEnabled,
        _conferenceView,
        _fullScreen,
        filmStripView,
        hasMeetingEndTime,
        joinanytime,
        isDeskTop,
        SHOW_MEET_HOUR_WATERMARK,
        displayLogoInRecorder,
        lobbyEnabled,
        interfaceConfigToolbarButtons,
        dispatch,
        t,
        hasShownExpiringNotification,
        onExpiringNotificationShown,
        onToolbarToggleFullScreen,
        renderE2EELabel,
        renderInsecureRoomNameLabel,
        renderLocalRecordingLabel,
        _localrecordingLabel,
        transcribingLabel,
        renderRecordingLabel,
        _recordingMode,
        renderTranscribingLabel,
        toggleParticipantsPane
    } = props;

    const isCountdownMeeting = !joinanytime && hasMeetingEndTime;
    const isMobile = getWindowWidth() < 500;
    const _visibleButtons = new Set(interfaceConfigToolbarButtons);

    const headerIcon = _conferenceView === 'fixed' ? FixedIcon : FloatingIcon;
    const headerBackground = {
        background: getBrandingColorPalette(interfaceConfig)?.primary
    };
    const conferencViewStyle = {
        flexDirection: _conferenceView === 'fixed' ? 'row' : 'row-reverse',
        background: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : ''
    };


    const indicators = _clickandpledgeform ? 1 : 0 + transcribingLabel ? 1 : 0 + _localrecordingLabel ? 1 : 0 + _recordingMode ? 1 : 0;

    const shouldHideTimer = (indicators === 1 && getWindowWidth() < 350)
        || (indicators === 2 && getWindowWidth() < 400)
        || (indicators === 3 && getWindowWidth() < 440);

    const headerviewiconStyle = {
        background: getBrandingColorPalette(interfaceConfig)?.primary
    };
    const headerviewtextStyle = {
        color: getBrandingColorPalette(interfaceConfig)?.primary
    };

    return (
        <div
            className = 'header_conference'
            style = { headerBackground }>
            <div className = 'header_conference_group_1'>
                {interfaceConfig.applyMeetingSettings
                    ? (!isDeskTop && (config.iAmRecorder ? displayLogoInRecorder : SHOW_MEET_HOUR_WATERMARK)) && (
                        <>
                            <div
                                className = 'header_conference_logo'
                                id = 'header-logo'>
                                <Watermarks />
                            </div>
                            <span />
                        </>
                    )
                    : !isDeskTop && (
                        <>
                            <div
                                className = 'header_conference_logo'
                                id = 'header-logo'>
                                <Watermarks />
                            </div>
                            <span />
                        </>
                    )
                }

                <p className = 'meeting-name'>
                    {_subject === undefined ? _conferenceSubject : _subject}
                </p>

                {!shouldHideTimer && <div
                    className = { `conference-timer-wrap${_isShowingLabels || _geturl || clickAndPledgeUrl ? ' has-labels' : ''}` }
                    id = 'conference-timer'>
                    {!isCountdownMeeting || isDeskTop
                        ? <ConferenceTimer />
                        : (
                            <>
                                <div
                                    className = 'timer-countdown-mobile'
                                    id = 'conference-timer-countdown'>
                                    <MeetingCountDown
                                        dispatch = { dispatch }
                                        hasShownExpiringNotification = { hasShownExpiringNotification }
                                        onExpiringNotificationShown = { onExpiringNotificationShown } />
                                </div>
                                <div className = 'timer-clock-desktop'>
                                    <ConferenceTimer />
                                </div>
                            </>
                        )
                    }
                </div>}
            </div>


            {_iAmRecorder && (
                <div
                    className = 'header_conference_group_2'
                    id = 'header-labels'>
                    {isCountdownMeeting && (
                        <div
                            className = 'countdown-above500'
                            id = 'conference-timer-countdown'>
                            <MeetingCountDown
                                dispatch = { dispatch }
                                hasShownExpiringNotification = { hasShownExpiringNotification }
                                onExpiringNotificationShown = { onExpiringNotificationShown } />
                        </div>
                    )}
                    <div
                        className = 'label_buttons participant_count'
                        onClick = { () => toggleParticipantsPane() }>
                        <Icon src = { IconParticipants } />
                        <p>{parseInt(_participantCount, 10) - 1}</p>
                    </div>
                </div>
            )}

            {_isPictureInPictureEnabled && (
                <div
                    className = 'header_conference_group_2'
                    id = 'header-labels'>
                    {_clickandpledgeform && (
                        <ClickPledgeIndicator
                            _isClickandPledgeEnabled = { _isClickandPledgeEnabled }
                            dispatch = { dispatch } />
                    )}
                    {renderRecordingLabel(MHRecordingConstants.mode.FILE)}
                    {renderRecordingLabel(MHRecordingConstants.mode.STREAM)}
                    {renderLocalRecordingLabel()}
                    {renderTranscribingLabel()}
                </div>
            )}

            {!_iAmRecorder && !_isPictureInPictureEnabled && (
                <div
                    className = 'header_conference_group_2'
                    id = 'header-labels'>
                    {(_isLocalScreenSharing || _remoteScreenshareParticipantNames) && (
                        <div
                            aria-label = 'Presentation'
                            className = 'header_presentation_badge'>
                            <div className = 'presentation_info'>
                                <span className = 'presentation_icon'>
                                    <Icon
                                        size = { 20 }
                                        src = { IconShareDesktop } />
                                </span>
                                <span className = 'presentation_text'>
                                    {_isLocalScreenSharing && (_remoteScreenshareParticipantNames ? `${t('chat.you')}, ` : `${t('chat.you')}`)}
                                    {_remoteScreenshareParticipantNames} (presenting)
                                </span>
                            </div>
                            {_isLocalScreenSharing && (
                                <Tooltip
                                    content = { t('toolbar.stopScreenSharing') }
                                    position = 'bottom'>
                                    <button
                                        className = 'stop_presenting_btn'
                                        onClick = { () => dispatch(startScreenShareFlow(false)) }>
                                        <span>{t('toolbar.stopScreenSharing')}</span>
                                    </button>
                                </Tooltip>
                            )}
                        </div>
                    )}
                    {_inBackstage && (
                        <div
                            aria-label = { t('webinar.backstageTitle') }
                            className = 'header_presentation_badge header_backstage_badge'>
                            <div className = 'presentation_info'>
                                <span className = 'presentation_icon'>
                                    <Icon
                                        color = '#ffffff'
                                        size = { 18 }
                                        src = { IconEyeOff } />
                                </span>
                                <span className = 'presentation_text'>
                                    <span className = 'presentation_title'>
                                        {t('webinar.backstageTitle')}
                                    </span>
                                    <span className = 'presentation_subtext'>
                                        {t(_heldBackstage
                                            ? 'webinar.backstageHeldDescription'
                                            : 'webinar.bannerSubtitle')}
                                    </span>
                                </span>
                            </div>
                            {!_heldBackstage && (
                                <Tooltip
                                    content = { t('webinar.goLive') }
                                    position = 'bottom'>
                                    <button
                                        className = 'stop_presenting_btn'
                                        onClick = { () => dispatch(goLive()) }
                                        type = 'button'>
                                        <span>{t('webinar.goLive')}</span>
                                    </button>
                                </Tooltip>
                            )}
                        </div>
                    )}
                    {_clickandpledgeform && (
                        <ClickPledgeIndicator
                            _isClickandPledgeEnabled = { _isClickandPledgeEnabled }
                            dispatch = { dispatch } />
                    )}
                    {!lobbyEnabled && !_iAmVisitor && !_inBackstage && (
                        <Tooltip
                            content = { t('lobby.enableDialogContent') }
                            position = 'bottom'>
                            <div className = 'label_buttons'>
                                <Icon
                                    size = { 50 }
                                    src = { IconExitDoor } />
                            </div>
                        </Tooltip>
                    )}
                    {renderE2EELabel()}
                    {renderInsecureRoomNameLabel()}
                    <VisitorsCountLabel />
                    {renderRecordingLabel(MHRecordingConstants.mode.FILE)}
                    {renderRecordingLabel(MHRecordingConstants.mode.STREAM)}
                    {renderLocalRecordingLabel()}
                    {renderTranscribingLabel()}

                    {isCountdownMeeting && (
                        <div
                            className = 'countdown-above500'
                            id = 'conference-timer-countdown'>
                            <MeetingCountDown
                                dispatch = { dispatch }
                                hasShownExpiringNotification = { hasShownExpiringNotification }
                                onExpiringNotificationShown = { onExpiringNotificationShown } />
                        </div>
                    )}

                    {_geturl && (
                        <a
                            className = 'video_space-view_strip dbox-donation-button donor-box'
                            href = { _geturl }
                            rel = 'noreferrer'
                            target = '_blank'>
                            <Icon src = { IconDonorBoxSettings } />
                            <span>{t('welcomepage.header.donate')}</span>
                        </a>
                    )}
                    {_visibleButtons.has('participant-count') && (
                        <Tooltip
                            content = { t('tooltip.participantCount') }
                            position = 'bottom'>
                            <div
                                className = 'label_buttons participant_count above1250'
                                onClick = { () => toggleParticipantsPane() }>
                                <Icon src = { IconParticipants } />
                                <p>{_participantCount}</p>
                            </div>
                        </Tooltip>
                    )}

                    {_visibleButtons.has('voicecommand') && (
                        <div className = 'voicecommand_label above1170'>
                            <VoiceCommandLabel _classname = { 'hvc' } />
                        </div>
                    )}

                    {_visibleButtons.has('fixed-floating') && (
                        <div className = 'above1110'><Tooltip
                            content = { t('tooltip.headerview') }
                            position = 'bottom'>
                            <button
                                className = 'header_conference_view'
                                onClick = { () => {
                                    const nextView = _conferenceView === 'fixed' ? 'float' : 'fixed';

                                    jitsiLocalStorage.setItem('conferenceView', nextView);
                                    dispatch(conferenceViewHandler(nextView));
                                } }
                                style = { conferencViewStyle }>
                                <div
                                    className = 'header_conference_view_icon'
                                    style = { headerviewiconStyle }>
                                    <Icon src = { headerIcon } />
                                </div>
                                <p style = { headerviewtextStyle }>
                                    {_conferenceView === 'fixed' ? t('settingsView.FixedView') : t('settingsView.FloatingView')}
                                </p>
                            </button>
                        </Tooltip></div>
                    )}

                    {_visibleButtons.has('settings') && (
                        <Tooltip
                            content = { t('settings.title') }
                            position = 'bottom'>
                            <div className = 'label_buttons above768'>
                                <ColoredIcon color = { '#fff' }>
                                    <SettingsButton showLabel = { false } />
                                </ColoredIcon>
                            </div>
                        </Tooltip>
                    )}

                    {_visibleButtons.has('fullscreen') && (
                        <Tooltip
                            content = { _fullScreen ? t('toolbar.exitFullScreen') : t('toolbar.enterFullScreen') }
                            position = 'bottom-right'>
                            <button
                                className = { `label_buttons full-screen-header-icon above970 ${_fullScreen ? 'exit-full-screen' : ''}` }
                                onClick = { () => onToolbarToggleFullScreen() }>
                                <Icon
                                    src = { _fullScreen ? IconExitFullScreen : IconFullScreen }
                                    width = { 20 } />
                            </button>
                        </Tooltip>
                    )}

                    {[ 'settings', 'fullscreen', 'fixed-floating', 'participant-count', 'voicecommand' ].some(btn => _visibleButtons.has(btn)) && (
                        <MenuSideBar
                            _filmStripView = { filmStripView }
                            _participantsLength = { _participantCount }
                            _visibleButtons = { _visibleButtons }
                            className = 'below1250'
                            dispatch = { dispatch }
                            indicators = { indicators }
                            isMobile = { isMobile }
                            joinanytime = { isCountdownMeeting }
                            subject = { _subject } />
                    )}
                </div>
            )}
        </div>
    );
};

/**
 * Maps Redux state to props for HeaderConference.
 */
function _mapStateToProps(state) {
    const { isEnabled, formGUID, giventToken } = state['features/clickandpledge'];
    const { lobbyEnabled } = state['features/lobby'];
    const { meetingDetails } = state['features/base/jwt'];
    const { conferenceSubject } = state['features/base/conference'];
    const { displayLogoInRecorder, SHOW_MEET_HOUR_WATERMARK } = interfaceConfig;
    const desktopApp = state[stateType.base.mtApi].desktopapp;
    const isDeskTop = interfaceConfig.ENABLE_DESKTOP_DEEPLINK === false && desktopApp === 1;
    const conferenceView = state['features/base/conference']?.conferenceView ?? 'fixed';
    const fullScreen = state['features/toolbox']?.fullScreen ?? false;
    const filmStripView = state['features/filmstrip']?.filmStripView ?? LAYOUTS.TILE_VIEW;
    const isShowingLabels = state['features/toolbox']?.labelsVisible ?? false;
    const geturl = state['features/donorbox']?.url;
    const clickAndPledgeUrl = state['features/clickandpledge']?.clickAndPledgeUrl
        || state['features/clickandpledge']?.meetData?.clickAndPledgeUrl;
    const isPictureInPictureEnabled = getPictureInPictureModeConfig(state);
    const interfaceConfigToolbarButtons = getToolbarButtons(state);
    const participantCount = getParticipantCount(state);
    const participants = state['features/base/participants'];
    const jwtData = state['features/base/jwt'];
    const { jwtData: jwtDataObj, jwt } = jwtData;
    const jwtSubject = jwt ?? jwtDataObj;

    let jwtDecoded;

    if (jwtSubject) {
        try {
            const jwtDecode = require('jwt-decode').default;
            const jwtt = jwtDecode(jwtSubject);

            jwtDecoded = jwtt ? jwtt.meeting ? jwtt.meeting.topic : null : null;
        } catch {
            jwtDecoded = null;
        }
    }
    const { isEngaged } = state['features/local-recording'];
    const recordingMode = state['features/recording'].recordingMode;
    const transcribingLabel = state['features/transcribing'].isTranscribing;


    const subject = meetingDetails?.topic ?? jwtDecoded ?? getConferenceName(state);

    const isLocalScreenSharing = participants.find(p => p.isFakeParticipant === 'LocalScreenShare');
    const remoteScreenshare = participants.filter(p => p.isFakeParticipant === 'RemoteScreenShare');
    const remoteScreenshareNames = remoteScreenshare
        .map(p => (p && p.name) || '')
        .filter(Boolean)
        .join(', ');

    return {
        _isLocalScreenSharing: isLocalScreenSharing,
        _iAmVisitor: iAmVisitor(state),
        _inBackstage: amIInBackstage(state),
        _heldBackstage: amIHeldBackstage(state),
        _localParticipantName: isLocalScreenSharing?.name,
        _remoteScreenshareParticipantNames: remoteScreenshareNames,
        _iAmRecorder: state['features/base/config'].iAmRecorder,
        _subject: subject,
        _conferenceSubject: conferenceSubject,
        _participantCount: participantCount,
        _isShowingLabels: isShowingLabels,
        _geturl: geturl,
        clickAndPledgeUrl,
        _isPictureInPictureEnabled: isPictureInPictureEnabled,
        _clickandpledgeform: giventToken ?? formGUID,
        _isClickandPledgeEnabled: isEnabled,
        _conferenceView: conferenceView,
        _fullScreen: fullScreen,
        filmStripView,
        _localrecordingLabel: isEngaged,
        _recordingMode: recordingMode,
        transcribingLabel,
        hasMeetingEndTime: Boolean(meetingDetails?.end_time && meetingDetails?.timezone),
        joinanytime: meetingDetails?.settings?.JOIN_ANYTIME === 1,
        isDeskTop,
        SHOW_MEET_HOUR_WATERMARK,
        displayLogoInRecorder,
        lobbyEnabled,
        interfaceConfigToolbarButtons
    };
}

export default connect(_mapStateToProps)(translate(HeaderConference));
